import { ActionConstants } from '../constants';

const user = (state = null, action) => {
  switch (action.type) {
    case ActionConstants.ADD_USER:
      return {
        id: action.payload.id,
        username: action.payload.username,
        theme: action.payload.theme,
        photoUrl: action.payload.photoUrl,
      }
    case ActionConstants.CHANGE_THEME:
      return {
        ...state,
        theme: action.payload,
      }
    case ActionConstants.DELETE_USER:
      return null;
    default:
      return state;
  }
}

export default user



// WEBPACK FOOTER //
// ./src/reducers/user.js